import type { Abi, Address } from 'viem';
import type { EvmFullFillCreateOrder } from '@/service/api/types';

export enum EvmItemType {
    NATIVE,
    ERC20,
    ERC721,
    ERC1155,
    ERC721_WITH_CRITERIA,
    ERC1155_WITH_CRITERIA
}

export enum EvmOrderType {
    FULL_OPEN,
    PARTIAL_OPEN,
    FULL_RESTRICTED,
    PARTIAL_RESTRICTED,
    CONTRACT
}

export type EvmContractType = {
    address: Address;
    abi: Abi;
    chainId?: number;
    version?: string;
    name?: string;
};

export type EvmConsideration = {
    itemType: EvmItemType;
    token: Address;
    identifierOrCriteria: number | string;
    startAmount: number | string;
    endAmount: number | string;
    recipient: Address;
};

export type EvmOtherRecipientType = {
    token: Address;
    address: Address;
    value: number;
    itemType: EvmItemType;
};

export type EvmFullFillOrderType = {
    amount1155?: number;
} & EvmFullFillCreateOrder;
